import { connect } from "react-redux";
import ZubehoerInfoPanel from "./ZubehoerInfoPanel";

export default connect()(ZubehoerInfoPanel);
